import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import ButtonWrapper from "../../components/Button";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Col, Container, Row } from "react-bootstrap";
import FileUploader from "../../../TCPForms/reusableComponents/FileUploader";

const Step2 = ({ formData, handleTabChange, initFormMTDocs }) => {
  const { documents } = useSelector((state) => state.formMT);
  const { t } = useTranslation();
  const defaultValues = {
    ...formData,
  };
  const { handleSubmit, control, watch, setValue, getValues, reset, trigger } = useForm({ defaultValues });
  const onSubmit = (data) => {
    handleTabChange(3, data);
  };
  const modalMsg = {
    title: "Building Plan Upload – Declaration",
    body: `<p style="font-size:14px; text-align:left;">
    Before uploading the building plan drawing, please ensure the following mandatory Do’s are complied with:
  </p>  <ul style="text-align:left; margin:10px 0; padding-left:20px; font-size:14px; list-style-type: disc;">
    <li style="margin-bottom:6px;">Always use the prescribed template for preparing the building plan map.</li>
    <li style="margin-bottom:6px;">Do not scale, stretch, rotate, crop, or modify the template in any manner.</li>
    <li style="margin-bottom:6px;">Always prepare, plot, print, and upload the drawing PDF in ISO A0 size.</li>
    <li style="margin-bottom:6px;">All drawings must be prepared using Meter (m) as the unit of measurement.</li>
    <li style="margin-bottom:6px;">Always select edge-to-edge template selection while creating the PDF.</li>
    <li style="margin-bottom:6px;">All plans, information, and data must remain strictly within the prescribed template area.</li>
    <li style="margin-bottom:6px;">Ensure there are no missing, extra, or duplicate elements outside the defined template boundary.</li>
    <li style="margin-bottom:6px;">Do not include watermarks, background images, or decorative graphics.</li>
    <li style="margin-bottom:6px;">Ensure compliance with all applicable Building Bye-laws, Development Control Regulations, and Authority norms.</li>
  </ul>

  <p style="font-size:14px; text-align:left;">
    By proceeding, you confirm that all the above conditions have been carefully reviewed and complied with.
  </p>

  <br/>`,
    type: "warning",
    redirectPath: null,

    btnText: "I Agree & Proceed",
  };
  useEffect(() => {
    if (formData?.documents?.length > 0) {
      initFormMTDocs(formData.documents);
    }
  }, [formData?.documents]);

  useEffect(() => {
    if (documents?.length >= 0) {
      setValue("documents", documents);
    }
  }, [documents, setValue]);
  const isScheme = formData?.descriptionOfLand?.schemeType === "Scheme" || formData?.schemeType === "Scheme";

  return (
    <section className="groupContainer2">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="formContainer">
          <div className="formHeaderContainer">
            <h2 className="formHeading">{"Documents Details"}</h2>
          </div>

          <Container fluid className="formInputContainer common-app-form self-certified custom-upload new-custom-uploader">
            <Row>
              <Col>
                <FileUploader
                  isMandatory
                  label={t("Drawing Pdf")}
                  control={control}
                  name="drawingPdf"
                  validationMsg="(pdf file only and Max file Size 30 MB)"
                  required
                  templateMessage={true}
                  trigger={trigger}
                  showModal={true}
                  modalMsg={modalMsg}
                />
              </Col>
              <Col>
                <FileUploader
                  isMandatory
                  label={t("Owner Signature")}
                  control={control}
                  name="signature"
                  validationMsg="(jpg, jpeg, png file only and Max file Size 10 MB)"
                  required
                  tab={2}
                  trigger={trigger}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <FileUploader
                  isMandatory
                  label={t("Ownership document PDF")}
                  control={control}
                  name="ownerShipDoc"
                  validationMsg="(pdf file only and Max file Size 30 MB)"
                  required
                  trigger={trigger}
                />
              </Col>
              <Col>
                {isScheme && (
                  <FileUploader
                    isMandatory
                    label={t("Sanction Layout")}
                    control={control}
                    name="sanctionLayout"
                    validationMsg="(pdf file only and Max file Size 30 MB)"
                    required
                    trigger={trigger}
                  />
                )}
              </Col>
            </Row>
          </Container>
        </div>

        <div className="footerContainer">
          <div className="buttonWrapper">
            <ButtonWrapper variant="contained" color="success" size="medium" label="Save" type="submit" sx={{ backgroundColor: "#157CB3" }} />
          </div>
        </div>
        {/* <div className="footerContainer">
          <div className="buttonWrapper">
            <ButtonWrapper 
              variant="contained" 
              color="primary" 
              size="medium" 
              label="Submit" 
              onClick={handleSubmit(onSubmit)} 
              sx={{ 
                backgroundColor: "#28a745",
                '&:hover': {
                  backgroundColor: "#218838"
                }
              }} 
            />
          </div>
        </div> */}
      </form>
    </section>
  );
};

export default Step2;
